import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CommonService } from '../service/common/common.service';
import { IS_SHOW_LOADER } from '../lib/custom-context';

@Injectable()
export class ManualAuthInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isManual = localStorage.getItem('manual-logged-in') === 'true';
    const token = localStorage.getItem('token');
    const isShowLoader = req.context.get(IS_SHOW_LOADER);
      if(isShowLoader){
        CommonService.showLoader();
      }
    // if (isManual && token) {
      const authReq = req.clone({
        setHeaders: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': req.method === 'POST' || req.method === 'PUT' ? 'application/json' : req.headers.get('Content-Type') || ''
        }
      });
      return next.handle(authReq);
    // }

    // return next.handle(req);
  }
}
